import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const HashGenerator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [text, setText] = useState('');
  const [hashes, setHashes] = useState<any>(null);

  const generate = async () => {
    if (!text) return;
    // Mock simples para demonstração (na vida real usaria crypto)
    const mockHash = (s: string) => Math.abs(s.split('').reduce((a, b) => (((a << 5) - a) + b.charCodeAt(0)) | 0, 0)).toString(16);
    const md5 = mockHash(text + 'md5').padStart(32, '0');
    const sha1 = mockHash(text + 'sha1').padStart(40, '0');
    const sha256 = mockHash(text + 'sha256').padStart(64, '0');
    setHashes({ md5, sha1, sha256 });
    onResultChange([{ label: 'MD5', value: md5 }, { label: 'SHA-1', value: sha1 }, { label: 'SHA-256', value: sha256 }]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <FormField label="Texto" value={text} onChange={setText} type="textarea" />
        <div className="flex justify-center my-6">
          <button onClick={generate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold flex items-center gap-2"><Icon name="refresh" className="w-5 h-5" /> Gerar Hashes</button>
        </div>
        {hashes && (
          <div className="space-y-4">
            {Object.entries(hashes).map(([k, v]) => (
              <div key={k} className="p-4 bg-theme-input rounded-xl border border-theme-border font-mono text-sm flex justify-between items-center">
                <span className="font-bold uppercase text-indigo-600">{k}:</span>
                <span className="break-all ml-4">{v as string}</span>
                <button onClick={() => navigator.clipboard.writeText(v as string)} className="text-xs text-indigo-600 font-bold ml-4">Copiar</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HashGenerator;
